/* eslint-disable react/prop-types */
import { Box } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { getStringTime, toString } from '../../../helpers/date'

const Container = styled(Link)`
  display: block;
  text-decoration: none!important;
  min-height: 180px;
  border: 1px solid #03A9F4;
  padding: 15px;
  background-color: #fff;
  height: 100%;
  border-radius: 5px;
  :hover {
    background-color: #2196f329;
  }
  @media screen and (max-width: 150px) {
    font-size: .9em;
  }
  @media screen and (max-width: 1350px) {
    font-size: .8em;
  }
`

const DateCOmponent = styled.div`
  text-align: center;
  font-size: 1.3em;
  font-weight: bold;
  color: var(--first);
`

const Row = styled.div`
  color: #000;
  font-size: 1.2em;
  text-align: center;
  span {
    font-weight: bold;
    margin-right: .5em;
    color: var(--first);
  }
`

const State = styled.span`
  color: ${props => props.$color}!important;
  font-weight: bold;
`

const Appointment = (props) => {
  return (
    <Container to={`/admin-appointment/${props.ownId}`}>
      <DateCOmponent>{toString(props.date)}</DateCOmponent>
      <DateCOmponent>{getStringTime(props.date)}</DateCOmponent>
      <Box pt={2} />
      <Row> <span>Nombre:</span> {props.name}</Row>
      <Row> <span>Apellidos:</span> {props.plastname} {props.mlastname}</Row>
      <Row> <span>Correo:</span> {props.email}</Row>
      <Box pt={2} />
      <Row>
        <span>
          Estado:
        </span>
        <State $color={props.isPaid ? 'green' : 'orange'}>
          {props.isPaid ? 'Pagado' : 'Pendiente'}
        </State>
      </Row>
    </Container>
  )
}

export default Appointment
